import './App.css';
import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { createTheme } from '@mui/material/styles';
import {FaFolder , FaUserTie, FaFolderMinus,FaRegSun,FaTooth   } from 'react-icons/fa';  
import { AppProvider } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { DemoProvider } from '@toolpad/core/internal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Patients from './patients';
import Upload from "./upload"

const NAVIGATION = [
  {
    segment: 'dashboard',
    title: 'Dashboard',
    icon: <FaFolder />,
  },
  {
    segment: 'newcase',
    title: 'New Case',
    icon: <FaFolderMinus />,
    children: [
      {
        segment: 'upload',
        title: 'Upload',
        icon: <FaFolderMinus />,
      },
      {
        segment: 'xray',
        title: 'X-Ray',
        icon: <FaFolderMinus />,
      },
    ],
  },
  {
    segment: 'patients',
    title: 'Patients',
    icon: <FaUserTie />,
  },
  {
    segment: 'settings',
    title: 'Settings',
    icon: <FaRegSun />,
  },
];

const demoTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-toolpad-color-scheme',
  },
  colorSchemes: { light: true},
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
});
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Anish Patel', "23/02/1989", 'Cron', 24, 4.0),
  createData('Rohit', '20/04/1989', "Compeleted", 37, 4.3),
  createData('Hsitesh', '20/04/1989', "Compeleted", 37, 4.3),
  createData('Rohan', '20/04/1989', "Compeleted", 37, 4.3),
  createData('Ronit', '20/04/1989', "Compeleted", 37, 4.3),
  
];
function DemoPageContent({ pathname }) {
  console.log("dfd",pathname)
  return <>

    { pathname=='/dashboard' && <Box
      sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography sx={{fontSize:28}}>Dashboard</Typography>
      <Box  sx={{mt:2}}>
      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="right">Date</TableCell>
            <TableCell align="right">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.calories}</TableCell>
              <TableCell align="right">{row.fat}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
      </Box>
    </Box>}
    { pathname=='/patients' && 
    <Box
    sx={{
      p: 4,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
      <Patients/>
      </Box>
}
{ pathname=='/newcase/upload' && 
  <Box
    sx={{
      p: 4,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Upload/>
    </Box>
    }
    </>
}

DemoPageContent.propTypes = {
  pathname: PropTypes.string.isRequired,
};

function App(props) {
  const { window } = props;

const [pathname, setPathname] = React.useState('/dashboard');

const router = React.useMemo(() => {
  return {
    pathname,
    searchParams: new URLSearchParams(),
    navigate: (path) => setPathname(String(path)),
  };
}, [pathname]);

// Remove this const when copying and pasting into your project.
const demoWindow = window !== undefined ? window() : undefined;

return (
  // Remove this provider when copying and pasting into your project.
  <DemoProvider window={demoWindow}>
    <AppProvider
      navigation={NAVIGATION}
      router={router}
      branding={{
        logo: <FaTooth />,
        title: 'SmileCopilot',
      }}
      theme={demoTheme}
      window={demoWindow}
    >
      {/* preview-start */}
      <DashboardLayout defaultSidebarCollapsed>
        <DemoPageContent pathname={pathname} />
      </DashboardLayout>
      {/* preview-end */}
    </AppProvider>
  </DemoProvider>
);
}

export default App;
